import { render } from "./dependents-radio-list.vue?vue&type=template&id=2073be9c&scoped=true"
import script from "./dependents-radio-list.vue?vue&type=script&lang=js"
export * from "./dependents-radio-list.vue?vue&type=script&lang=js"

import "./dependents-radio-list.vue?vue&type=style&index=0&id=2073be9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2073be9c"]])

export default __exports__